import React, { useState } from "react";
import { useAddVideosMutation } from "../../features/Videos/VideosApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const AddVideo = () => {
  const [addVideos, { data, isLoading, error: resError }] =
    useAddVideosMutation();
  const [formData, setData] = useState({
    title: "",
    description: "",
    url: "",
    views: "",
    duration: "",
    createdAt: new Date(),
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(addVideos(formData));

    navigate("/admin/videos");
  };

  const changeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setData({ ...formData, [name]: value });
  };
  return (
    <div>
      <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
        <input type="hidden" name="remember" value="true" />
        <div className="rounded-md shadow-sm -space-y-px">
          <div>
            <label for="title" className="sr-only">
              Title
            </label>
            <input
              id="title"
              name="title"
              type="text"
              autocomplete="title"
              required
              className="login-input rounded-t-md"
              placeholder="Title"
              value={formData.title}
              onChange={changeHandler}
            />
          </div>
          <div>
            <label for="description" className="sr-only">
              Description
            </label>
            <textarea
              id="description"
              name="description"
              rows="4"
              cols="50"
              autocomplete="description"
              required
              className="login-input "
              placeholder="Description"
              value={formData.description}
              onChange={changeHandler}
            />
          </div>
          <div>
            <label for="url" className="sr-only">
              URL
            </label>
            <input
              id="url"
              name="url"
              type="text"
              autocomplete="url"
              required
              className="login-input"
              placeholder="URL"
              value={formData.url}
              onChange={changeHandler}
            />
          </div>
          <div>
            <label for="views" className="sr-only">
              Views
            </label>
            <input
              id="views"
              name="views"
              type="text"
              autocomplete="views"
              required
              className="login-input rounded-b-md"
              placeholder="Views"
              value={formData.views}
              onChange={changeHandler}
            />
          </div>
          <div>
            <label for="duration" className="sr-only">
              Duration
            </label>
            <input
              id="duration"
              name="duration"
              type="text"
              autocomplete="duration"
              required
              className="login-input rounded-b-md"
              placeholder="Duration"
              value={formData.duration}
              onChange={changeHandler}
            />
          </div>
        </div>

        <div>
          <button
            type="submit"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            disabled={isLoading}
          >
            Add Video
          </button>
        </div>
        {resError !== "" && <span>{resError}</span>}
      </form>
    </div>
  );
};

export default AddVideo;
